const ArrowBackIcon = () => `<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    width="100%" height="100%"
    viewBox="0 0 24 24">
    <polygon points="21,11 5.4,11 11.7,4.7 10.3,3.3 1.6,12 10.3,20.7 11.7,19.3 5.4,13 21,13 " />
  </svg>`;
export default ArrowBackIcon;
